"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _base = require("@mui/base");
var _Style = require("../style/Style");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _default = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
      ...stylex.props(_Style.buttonStyle.primary),
      children: "Button"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
      ...stylex.props(_Style.buttonStyle.secondary),
      children: "Button"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
      ...stylex.props(_Style.buttonStyle.disabled),
      children: "Button"
    })]
  });
};
exports.default = _default;